// src/components/properties/PropertiesResults/PropertiesResults.jsx
import React from "react";
import { FiGrid } from "react-icons/fi";
import PropertyCard from "./PropertyCard";
import "./PropertiesResults.css";

export default function PropertiesResults({ result = [], onLoading }) {
  return (
    <section className="pr">
      <div className="container">
        <div className="pr__top">
          <div className="pr__summary">
            <span className="pr__icon"><FiGrid /></span>
            <div>
              <div className="pr__label">Results</div>
              <div className="pr__text">Showing <strong>{result?.length || 0}</strong></div>
            </div>
          </div>
        </div>
        <div className="pr__grid">
          {onLoading
            ? Array.from({ length: 6 }).map((_, i) => <PropertyCard key={i} loading />)
            : result.map((p) => <PropertyCard key={p._id} item={p} />)}
        </div>
        {!onLoading && !result?.length ? <div className="pr__more"><button className="pr__moreBtn" type="button" disabled>No properties found for the selected filters</button></div> : null}
      </div>
    </section>
  );
}
